export default "__VITE_ASSET__fBEaHgJw__"